module.exports = __webpack_public_path__ + "media/images/vector-136@2x-46eda8afdbb63135e9a984f160780f71.png";